import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Programs from "../pages/programs/page";
import Trainers from "../pages/trainers/page";
import About from "../pages/about/page";
import Gallery from "../pages/gallery/page";
import Contact from "../pages/contact/page";
import PrivateTraining from "../pages/programs/PrivateTraining";
import GroupTraining from "../pages/programs/GroupTraining";
import YouthProgram from "../pages/programs/YouthProgram";
import HomeTraining from "../pages/programs/HomeTraining";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/programs",
    element: <Programs />,
  },
  {
    path: "/trainers",
    element: <Trainers />,
  },
  {
    path: "/programs/private-training",
    element: <PrivateTraining />,
  },
  {
    path: "/programs/group-training",
    element: <GroupTraining />,
  },
  {
    path: "/programs/youth-program",
    element: <YouthProgram />,
  },
  {
    path: "/programs/home-training",
    element: <HomeTraining />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;